import React from 'react';
import { Reveal } from './Reveal';
export function Testimonial() {
  return <section className="border-y border-line bg-surface" data-id="element-305" data-mp="z5r8fvw4jnq4">
      <Reveal className="mx-auto max-w-4xl px-6 py-28" data-id="element-306" data-mp="z581tbbxclre">
        <figure data-id="element-307" data-mp="l6rmwx3wroy6">
          <blockquote className="font-display text-3xl font-medium leading-snug tracking-tight md:text-4xl" data-id="element-308" data-mp="l56rl59rs1z9">
            “We shipped card payments in six LATAM countries and nobody got on a plane. LocalTask folks caught two issuer
            declines before a single real customer did. <span className="text-accent" data-id="element-309" data-mp="g7ndc5d2np7b">Kind of wild.</span>”
          </blockquote>
          <figcaption className="mt-10 flex items-center gap-4" data-id="element-310" data-mp="1iisshit18w1">
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-accent-soft font-display font-semibold text-accent" data-id="element-311" data-mp="1k28o70jthxa">MO</span>
            <span data-id="element-312" data-mp="3omf73ih0ypqt">
              <span className="block font-medium" data-id="element-313" data-mp="3oo02fab5ycpq">Mariana Ortiz</span>
              <span className="block font-mono text-xs text-muted" data-id="element-314" data-mp="3tlrzsjukur1b">payments qa lead @ kova</span>
            </span>
          </figcaption>
        </figure>
      </Reveal>
    </section>;
}